module.exports = __webpack_public_path__ + "img/up-arrow-icon.e2be2dae.svg";